import React, { memo } from "react";
import { Box, Button, Typography } from "@mui/material";
import { ReactComponent as InfoCircleIcon } from "@assets/svg/info_circle.svg";
import { bankExtractionCopy } from "@investorRequest/constants/bankExtractionCopy";
import { paymentMethodLabel } from "@investorRequest/utils/applyExtractionResult";

interface Props {
  detectedPaymentMethod: string;
  onSwitch: () => void;
}

const BankExtractionMethodMismatch = ({ detectedPaymentMethod, onSwitch }: Props) => {
  const label = paymentMethodLabel(detectedPaymentMethod);

  return (
    <Box
      data-testid="bank-extraction-method-mismatch"
      role="note"
      sx={{
        bgcolor: "info.light",
        borderLeft: "4px solid",
        borderColor: "info.main",
        p: 2,
        mb: 3,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
      }}
    >
      <InfoCircleIcon width={20} height={20} aria-hidden />
      <Typography variant="body1">
        {bankExtractionCopy.methodMismatch(label)}{" "}
        <Button
          variant="text"
          color="info"
          onClick={onSwitch}
          sx={{ textDecoration: "underline", p: 0, minWidth: 0, verticalAlign: "baseline" }}
        >
          Switch to {label}
        </Button>
      </Typography>
    </Box>
  );
};

export default memo(BankExtractionMethodMismatch);
